import { ICourseModulesNodes } from '@dtos/Course'
import { IEnrollment } from '@dtos/Enrollment'
import { IFeaturedProduct } from '@dtos/MembersConfig'

interface IModuleCardDataParams {
  module: ICourseModulesNodes
  lessonsCompletedPerModule: IEnrollment['lessonsCompletedPerModule']
  featuredProduct: Pick<IFeaturedProduct, 'productLogo' | 'productLogoVertical'>
}

export interface IModuleCardData {
  id: string
  title: string
  logo?: string
  logoVertical?: string
  completedLessons: number
  totalLessons: number
  progress: number
  isAvailable: boolean
}

/**
 * Dados do `ProductCard` para um módulo na home focada.
 *
 * `lessonsCompletedPerModule` e `courseContentsCount` contam só as aulas do
 * próprio módulo (provado na T018), então o card soma os submódulos para que o
 * progresso cubra tudo o que o aluno vê ao entrar no módulo.
 */
export function moduleToProductCardData({
  module,
  lessonsCompletedPerModule,
  featuredProduct,
}: IModuleCardDataParams): IModuleCardData {
  const scopes = [module, ...(module.courseModules || [])]
  const completedLessons = scopes.reduce(
    (sum, scope) => sum + (lessonsCompletedPerModule?.[scope.id] || 0),
    0,
  )
  const totalLessons = scopes.reduce(
    (sum, scope) => sum + (scope.courseContentsCount || 0),
    0,
  )
  // floor: o card só vira "Concluído" com 100, e arredondar para cima marcaria
  // 199 de 200 como concluído.
  const progress = totalLessons
    ? Math.min(100, Math.floor((completedLessons / totalLessons) * 100))
    : 0
  const cover =
    module.coverUrl ||
    featuredProduct.productLogoVertical ||
    featuredProduct.productLogo ||
    undefined

  return {
    id: `module-${module.id}`,
    title: module.name,
    logo: cover,
    logoVertical: cover,
    completedLessons,
    totalLessons,
    progress,
    isAvailable: module.available !== false,
  }
}
